// extracted by mini-css-extract-plugin
export default {"flexRow":"chartFlexRow_flexRow__KBpHk"};